module.exports = __webpack_public_path__ + "static/media/aa-pictures.eaa4e331.png";